import { render } from "./About.vue?vue&type=template&id=f529d73a&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=f529d73a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f529d73a"]])

export default __exports__